import axios from "axios";
import { Base64Encoder, decodeJWT, getESGReqHeader, getRefreshTokenHeader, getReqHeader, loginClientId, setTokenInfo, writeToken } from "./tool-service";
import { environment } from "../environment";
import { apiS } from "./api-base";


export const dataEncryption = async (password) => {
    let reqBody = {
      ReqHeader: getReqHeader('dataEncryption'),
      ReqBody: {
        data: password
      }
    }  
    let url = `${environment.apiUrl}/dgrv4/ssotoken/dataEncryption`
    return axios.post(url,reqBody)
  }

  export const jweEncryption = async (username,password) => {
    let reqBody = {
      ReqHeader: getReqHeader('jweEncryption'),
      ReqBody: {
        dataMap:{
          username:username,
          password:password
        }
      }
    }  
    let url = `${environment.apiUrl}/dgrv4/ssotoken/jweEncryption`
    return axios.post(url,reqBody)
  }

  export const gtwidp_login = async (uname,mima,params) => {
    let tarUrl = `${environment.apiUrl}/dgrv4/ssotoken/gtwidp/API/gtwlogin?username=${uname}&password=${mima}`;  
    return await axios(`${tarUrl}${params}`);
  }

  export const gtwidp_login_credential = async (credential,params) => {
    let tarUrl = `${environment.apiUrl}/dgrv4/ssotoken/gtwidp/API/gtwlogin?credential=${credential}`;  
    return await axios(`${tarUrl}${params}`);
  }

  export const gtwidp_approve = async (username,redirect_uri,state,scope)=>{
    let tarUrl = `${environment.apiUrl}/dgrv4/ssotoken/gtwidp/API/approve?username=${username}&redirect_uri=${redirect_uri}&state=${state}&scope=${scope.join('%20')}`
    return await axios(tarUrl);
  }

  

  // google idp 登入
  export const gtwidp_authorization = async (redirect_uri,state,scope,loginType,codeChallenge,cusClientId="")=>{
    let themeColorSession = sessionStorage?.getItem("loadTheme")!=="undefined"&&sessionStorage?.getItem("loadTheme")!==null?sessionStorage?.getItem("loadTheme"):'green';
    let clientId = loginClientId(themeColorSession);
    

    const params = new URLSearchParams()
    params.append('response_type', "code");
    params.append('client_id', cusClientId!==''?cusClientId:clientId);
    params.append('scope', scope);
    params.append('redirect_uri',redirect_uri);
    params.append('state',state);
    params.append('code_challenge',codeChallenge);
    params.append('code_challenge_method',"S256");

    window.location.href = `${environment.apiUrl}/dgrv4/ssotoken/gtwidp/${loginType}/authorization?${params}`;//直接轉導就好不需要透過axios

    // return await axios(`${environment.apiUrl}/dgrv4/ssotoken/gtwidp/${loginType}/authorization?${params}`,{
    //     headers:{
    //         'Authorization': `Basic ${Base64Encoder(clientId+":")}`,//需要開啟PKCE
    //         'Content-Type': 'application/x-www-form-urlencoded'
    //     },
    //     // paramsSerializer: params => params
    // })
  }

  export const getRefreshToken = async (args) => {
    // Authorization: Basic Base64Encoder(EsgCustomer)
    return await apiS({ url: `/oauth/token`, method: 'post', data: args },true)
}

//登出註銷token //access_token refresh_token
export const revocationToken = async (tokenType="access_token") => {
  let themeColorSession = sessionStorage?.getItem("loadTheme")!=="undefined"&&sessionStorage?.getItem("loadTheme")!==null?sessionStorage?.getItem("loadTheme"):'green';
  let clientId = loginClientId(themeColorSession);
    const params = new URLSearchParams()
    params.append('token', sessionStorage?.getItem(tokenType))
    params.append('token_type_hint', tokenType)
    params.append('client_id', clientId)
  // return await apiS({ url: `/oauth/revocation`, method: 'post', data: params },false,false)
  return await axios.post(`${environment.apiUrl}/oauth/revocation`,params,{
    paramsSerializer: params => params
  })
  .then((res)=>{
    if(res){
      return res;
    }else{
      if(res?.response?.status === 401 || res?.response?.status === 403){
        window.location.href = `/${environment.contextPath}/${environment.contextVersion}/${environment.front}/login?re=${Base64Encoder(res?.response?.data)}`;
      }
    }
  }).catch((err)=>{
      if (err.message.includes('Network Error')) {
        window.location.href = `/${environment.contextPath}/${environment.contextVersion}/${environment.front}/login`;// 導向登錄頁面
      } else {
        if(err?.response?.status === 401 || err?.response?.status === 403){
        window.location.href = `/${environment.contextPath}/${environment.contextVersion}/${environment.front}/login?re=${Base64Encoder(err?.response?.data?.error)}`;
        }
    }
   
})
}


